<template>
  <div class="product-full">
    <BasicTemplate :page-id="3">
      <ProductInfo :data="data" :product="product" />
    </BasicTemplate>
  </div>
</template>

<script>
import BasicTemplate from "./BasicTemplate.vue";
import ProductInfo from "../containers/ProductInfo.vue";

import utils from "../utils";
import firestoreUtils from "../firestore-utils";
export default {
  name: "ProductFull",
  data() {
    return {
      product: undefined,
      data: undefined,
      utils: utils,
      metaTitle: undefined,
      metaDescription: undefined,
      metaKeywords: undefined,
      metaImage: undefined,
      metaUrl: undefined,
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        { name: "yandex-verification", content: "b7c03678b09c3394" },
        {
          name: "title",
          property: "title",
          content: this.metaTitle,
        },
        {
          name: "description",
          property: "description",
          content: this.metaDescription,
        },
        {
          name: "keywords",
          property: "keywords",
          content: this.metaKeywords,
        },
        {
          name: "og:title",
          property: "og:description",
          content: this.metaTitle,
        },
        {
          name: "og:description",
          property: "og:description",
          content: this.metaDescription,
        },
        {
          name: "og:image",
          property: "og:image",
          content: this.metaImage,
        },
        {
          name: "og:url",
          property: "og:url",
          content: this.metaUrl,
        },
      ],
    };
  },
  watch: {},
  methods: {
    fetchData() {
      this.data = undefined;
      this.doc = undefined;

      let id = parseInt(this.$route.params.id);
      if (id) {
        firestoreUtils
          .fetchWithFilter("productslist", {
            field: "id",
            condition: "==",
            value: id,
          })
          .then(result => {
            console.log(result[0]);
            const product = result.data[0];
            this.metaUrl = window.location.href;
            this.metaImage = product.meta.img.src;
            this.metaTitle = product.meta.title;
            this.metaDescription = product.meta.description;
            this.metaKeywords = product.meta.keywords;

            this.product = product;
            setTimeout(() => {
              document.dispatchEvent(new Event("x-app-rendered"));
            }, 5000);
          })
          .catch(err => {
            console.log(err);
            this.product = undefined;
          });
      }
    },
  },
  mounted() {
    console.log(this.product);
    this.current = 0;
    this.fetchData();
    firestoreUtils.fetchData("product").then(data => {
      console.log(data);
      this.data = data;
      setTimeout(() => {
        document.dispatchEvent(new Event("x-app-rendered"));
      }, 5000);
    });
  },
  components: {
    BasicTemplate,
    ProductInfo,
  },
};
</script>

<style lang="scss">
.product-full {
  .app-container {
    background: transparent;
  }
}
</style>
